import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddHostDetails, SendOTPEmail, VerifyOTPEmail, emailOtpReceived, getLoggedUser, getOtpSentStatus, getOtpVerifyStatus, validate, verifiedOtp, verifiedOtpFailed } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../services/appAlerts";

const maskEmail = (email) => {
  if (!email || !email.includes("@")) return "";
  const [name, domain] = email.split("@");
  return `${name.slice(0, 2)}.....@${domain}`;
};

const ValidateUser = () => {
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [codeToEmail, setCodeToEmail] = useState(false);
  const [codeToMobile, setCodeToMobile] = useState(false);
  const [verifyBlock, setVerifyBlock] = useState(false);
  const [reSendCodeMsg, setReSendCodeMsg] = useState(false);

  const [btnEmailLoading, setBtnEmailLoading] = useState(false);
  const [btnMobileLoading, setBtnMobileLoading] = useState(false);
  const [verifyBtnLoding, setVerifyBtnLoding] = useState(false);
  const [reSendCodeBtnLoding, setReSendCodeBtnLoding] = useState(false);

  const [currentUser, setCurrentUser] = useState("");

  const usrType = localStorage.getItem("userType");

  const loggedUser = useSelector(getLoggedUser);
  const emailOtpSentSelector = useSelector(getOtpSentStatus);
  const verifyOtpStatusSelector = useSelector(getOtpVerifyStatus);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loggedUser.user && !loggedUser.token) {
      navigate("/");
    }
    if (loggedUser.user && loggedUser.token) {
      navigate("/workplaces", { replace: true });
    }
    if (loggedUser.user && !loggedUser.token) {
      setCurrentUser(loggedUser.user);
    }
  }, [loggedUser, navigate]);

  useEffect(() => {
    if (emailOtpSentSelector === "success") {
      setCodeToEmail(true);
      setVerifyBlock(true);
      setCodeToMobile(false);
      setBtnEmailLoading(false);
      setReSendCodeMsg(reSendCodeBtnLoding);
      setReSendCodeBtnLoding(false);
      dispatch(emailOtpReceived(""));
    }
    if (emailOtpSentSelector === "fail") {
      getAlert("", "Authentication Failed", "error");
      setBtnEmailLoading(false);
      setReSendCodeBtnLoding(false);
      dispatch(emailOtpReceived(""));
    }
  }, [emailOtpSentSelector]);

  useEffect(() => {
    if (verifyOtpStatusSelector === "success") {
      const tempPwd = localStorage.getItem("tempPwd");
      dispatch(validate(currentUser.id, currentUser.email, tempPwd));
      dispatch(AddHostDetails({ userId: currentUser.id, email: currentUser.email }));
      setVerifyBtnLoding(false);
      getAlert("", "Authenticated Successfully", "success");
      setCode("");
      setCodeError("");
    }

    if (verifyOtpStatusSelector === "fail") {
      setCodeError("Invalid Code");
      setVerifyBtnLoding(false);
      dispatch(verifiedOtpFailed(""))
    }
  }, [verifyOtpStatusSelector]);

  const handleSendCodeToEmail = () => {
    setBtnEmailLoading(true);
    setReSendCodeMsg(false);
    dispatch(SendOTPEmail(currentUser.username, currentUser.email));
  };

  const handleVerifyCode = () => {
    setVerifyBtnLoding(true);
    dispatch(VerifyOTPEmail(currentUser.email, code));
  };

  const handleSendCodeToMobile = async () => {
    // reserved for mobile OTP support
  };

  const handleBack = () => {
    setVerifyBlock(false);
    setCodeToEmail(false);
    setCodeToMobile(false);
    setCode("");
    setCodeError("");
    setReSendCodeMsg(false);
  };

  const handleResendCode = async () => {
    setReSendCodeBtnLoding(true);
    setReSendCodeMsg(false);
    if (codeToEmail && !codeToMobile) {
      dispatch(SendOTPEmail(currentUser.username, currentUser.email));
    }
  };

  const handleCodeChange = ({ currentTarget }) => {
    setCode(currentTarget.value);
    if (codeError) {
      setCodeError("");
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell verify-shell">
        <div className="login-top-banner">
          <i className="fa fa-shield" aria-hidden="true"></i>
          <span>Human Resources Information Management System (HRIMS)</span>
        </div>
        <section className="login-hero" aria-label="Identity verification overview">
          <p className="login-kicker">Security Check</p>
          <h1>Verify your identity</h1>
          <p className="login-copy">
            We use a one-time security code before opening your WorkFINITY&reg; workspace.
          </p>
          <div className="login-hero-account">
            <div>
              <span>User Type</span>
              <strong>{usrType || "Portal user"}</strong>
            </div>
            <div>
              <span>Username</span>
              <strong>{currentUser?.username || "Pending"}</strong>
            </div>
          </div>
        </section>

        <section className="login-panel" aria-label="Verify identity">
          <div className="login-card verify-card">
            <div className="login-card-header">
              <p className="login-step-label">Multi-factor authentication</p>
              <h2>Security code</h2>
              {!codeToEmail && !codeToMobile && (
                <p>Select where you want to receive your one-time security code.</p>
              )}
              {codeToEmail && (
                <p>
                  We have sent a security code to <strong>{maskEmail(currentUser?.email)}</strong>.
                </p>
              )}
              {codeToMobile && (
                <p>
                  We have sent a security code to the mobile number ending in{" "}
                  <strong>
                    {currentUser?.mobile?.slice(currentUser.mobile.length - 4)}
                  </strong>.
                </p>
              )}
            </div>

            {!verifyBlock && (
              <div className="verify-choice">
                <button
                  className="btn btn-outline-default verify-choice-button"
                  disabled={btnEmailLoading || !currentUser?.email}
                  onClick={handleSendCodeToEmail}
                >
                  {btnEmailLoading ? (
                    <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-envelope-o mr-2" aria-hidden="true"></i>
                  )}
                  {btnEmailLoading ? "Sending code..." : "Send to my email"}
                </button>
              </div>
            )}

            {verifyBlock && (
              <div className="verify-form">
                <div className="form-group">
                  <label htmlFor="code" className="form-control-label">
                    Enter your security code
                  </label>
                  <input
                    type="text"
                    id="code"
                    name="code"
                    className="form-control"
                    value={code}
                    placeholder="Security code"
                    onChange={handleCodeChange}
                  />
                  {Boolean(codeError) && (
                    <div className="alert alert-danger mt-2 mb-0">{codeError}</div>
                  )}
                </div>

                <div className="verify-actions">
                  <button
                    className="btn btn-outline-default"
                    disabled={!Boolean(code) || verifyBtnLoding}
                    onClick={handleVerifyCode}
                  >
                    {verifyBtnLoding ? (
                      <React.Fragment>
                        <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
                        Verifying...
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <i className="fa fa-check mr-2" aria-hidden="true"></i>
                        Verify
                      </React.Fragment>
                    )}
                  </button>
                  <button
                    className="login-link"
                    style={{ border: "none", background: "none", boxShadow: "none", textDecoration: "none", cursor: "pointer" }}
                    disabled={verifyBtnLoding}
                    onClick={handleBack}
                  >
                    Back
                  </button>
                </div>

                <div className="verify-resend">
                  <span>Did not receive the code?</span>
                  <button
                    className="btn btn-sm btn-link"
                    disabled={reSendCodeBtnLoding}
                    onClick={handleResendCode}
                  >
                    {reSendCodeBtnLoding && (
                      <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
                    )}
                    {reSendCodeBtnLoding ? "Resending..." : "Resend Code"}
                  </button>
                  {reSendCodeMsg && (
                    <strong>Security code sent successfully.</strong>
                  )}
                </div>
              </div>
            )}
          </div>
        </section>
        <div className="login-saas-banner">
          <i className="fa fa-cloud" aria-hidden="true"></i>
          <span>
            SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
          </span>
        </div>
      </div>
    </div>
  );
}

export default ValidateUser;
